var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaretSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.333374C3.32667 0.333374 0.333336 3.32671 0.333336 7.00004C0.333336 10.6734 3.32667 13.6667 7 13.6667C10.6733 13.6667 13.6667 10.6734 13.6667 7.00004C13.6667 3.32671 10.6733 0.333374 7 0.333374ZM9.70667 8.19337C9.60667 8.29337 9.48 8.34004 9.35334 8.34004C9.22667 8.34004 9.1 8.29337 9 8.19337L7 6.19337L5 8.19337C4.80667 8.38671 4.48667 8.38671 4.29334 8.19337C4.1 8.00004 4.1 7.68004 4.29334 7.48671L6.64667 5.13337C6.84 4.94004 7.16 4.94004 7.35334 5.13337L9.70667 7.48671C9.9 7.68671 9.9 8.00004 9.70667 8.19337Z",
    fill: "#27B636"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretSuccess);
export default __webpack_public_path__ + "static/media/caret-success.8762c182.svg";
export { ForwardRef as ReactComponent };